module.exports = __webpack_public_path__ + "dafa82caac7742ec31c345b3777a0d12.png";